import { useState } from 'react';
import { rankingToday, rankingWeek } from '@/mocks/home';
import Reveal from '@/components/base/Reveal';

type TabKey = 'today' | 'week';

const TREND_ICON: Record<string, string> = {
  up: 'ri-arrow-up-line text-primary-500',
  down: 'ri-arrow-down-line text-secondary-500',
  flat: 'ri-subtract-line text-foreground-400',
};

export default function HotRanking() {
  const [tab, setTab] = useState<TabKey>('today');
  const list = tab === 'today' ? rankingToday : rankingWeek;

  return (
    <section id="ranking" className="w-full bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.4fr)] lg:gap-14">
          <Reveal>
            <div className="lg:sticky lg:top-28">
              <span className="text-xs font-bold tracking-[0.3em] text-primary-600 md:text-sm">HOT INDEX</span>
              <h2 className="mt-3 font-heading text-2xl font-black leading-tight text-foreground-950 md:text-4xl">
                热度榜单
                <br />
                最受关注节点
              </h2>
              <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600 md:text-base">
                按公开讨论量与转发规模排序，热度越高的节点越靠前，方便你快速抓住大众视线聚焦在哪一环。
              </p>

              <div className="mt-7 inline-flex rounded-full bg-background-200/70 p-1">
                <button
                  type="button"
                  onClick={() => setTab('today')}
                  className={`whitespace-nowrap rounded-full px-5 py-2 text-sm font-semibold transition-colors ${
                    tab === 'today'
                      ? 'bg-primary-500 text-background-50'
                      : 'text-foreground-600 hover:text-foreground-900'
                  }`}
                >
                  今日热度
                </button>
                <button
                  type="button"
                  onClick={() => setTab('week')}
                  className={`whitespace-nowrap rounded-full px-5 py-2 text-sm font-semibold transition-colors ${
                    tab === 'week'
                      ? 'bg-primary-500 text-background-50'
                      : 'text-foreground-600 hover:text-foreground-900'
                  }`}
                >
                  本周累计
                </button>
              </div>
            </div>
          </Reveal>

          <Reveal delay={80}>
            <ul className="flex flex-col gap-3 md:gap-4">
              {list.map((row) => (
                <li
                  key={row.name}
                  className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 md:gap-6 md:p-5"
                >
                  <span
                    className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-md font-heading text-lg font-black md:h-12 md:w-12 md:text-xl ${
                      row.rank <= 3
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-secondary-100 text-secondary-800'
                    }`}
                  >
                    {row.rank}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center justify-between gap-3">
                      <h3 className="truncate text-sm font-semibold text-foreground-900 md:text-base">
                        {row.name}
                      </h3>
                      <span className="flex shrink-0 items-center gap-1 text-xs font-bold text-foreground-800 md:text-sm">
                        <i className={TREND_ICON[row.trend]} />
                        {row.heat}
                      </span>
                    </div>
                    <div className="mt-3 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                      <div
                        className="h-full rounded-full bg-gradient-to-r from-primary-500 to-accent-500 transition-all duration-700"
                        style={{ width: row.width }}
                      />
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}